










import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import Masonry from 'masonry-layout';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import TeaserTilesItem from '@/webcomponents/teaser-tiles/TeaserTilesItem.vue';
import ExpandMedia from '@/webcomponents/expand-media/ExpandMedia.vue';
import ResponsiveImage from '@/common/vue/ResponsiveImage.vue';
import ParentComponentMixin from '@/common/ts/child-component/ParentComponentMixin';
import IntersectionDirective from '@/common/vue/intersection-directive';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import i18n from '@/webcomponents/teaser-tiles/i18n';

const TeaserTilesProps = Vue.extend({
  props: {
    editMode: Boolean,
    backgroundColor: {
      type: String,
      default: 'white',
      validator: (val) => ['white', 'black'].includes(val),
    },
  },
});

@Component({
  components: {
    ExpandMedia,
    ResponsiveImage,
  },
  directives: {
    intersect: IntersectionDirective,
  },
  i18n,
})
export default class TeaserTiles extends mixins(TeaserTilesProps, ParentComponentMixin, ResizeUpdateMixin) {
  childCollection = new ChildComponentCollection<TeaserTilesItem>();
  hasParsysWrapper = false;
  parsys: Element | null = null;
  msnry: Masonry | null = null;

  observerOptions = {
    threshold: 0,
  }

  get size () {
    return this.childCollection.items.length;
  }

  get isSingle () {
    return this.size === 1;
  }

  get rootClass () {
    return {
      'brandhub-teaser-tiles--edit-mode': this.editMode,
      'brandhub-teaser-tiles--background-white': this.backgroundColor === 'white',
      'brandhub-teaser-tiles--background-black': this.backgroundColor === 'black',
      'brandhub-teaser-tiles--single-item': this.size === 1,
      'brandhub-teaser-tiles--parsys-wrapper': this.hasParsysWrapper,
    };
  }

  initMansonry () {
    if (this.isDesktop && !this.isSingle && this.parsys) {
      this.msnry = new Masonry(this.parsys, {
        itemSelector: '.teasertilesitem',
        resize: true,
        horizontalOrder: true,
      });
    } else if (this.msnry && this.msnry.destroy) {
      this.msnry.destroy();
    }
  }

  handleIntersect (isIntersecting: boolean) {
    if (isIntersecting) {
      this.childCollection.forEach((item) => {
        item.forceLoad();
      });
    }
  }

  created () {
    this.initParentComponentMixin(
      this.childCollection,
      ['TeaserTilesItem'],
      (addedItem) => {
        const teaserTilesItem = addedItem as TeaserTilesItem;
        teaserTilesItem.backgroundColor = this.backgroundColor;
        if (this.childCollection.items.length === 1) {
          teaserTilesItem.isSingle = true;
        } else {
          this.childCollection.items.forEach((item) => {
            item.isSingle = false;
          });
        }
        this.initMansonry();
      },
    );
  }

  mounted () {
    if (this.$el.querySelector('.parsys')) {
      this.hasParsysWrapper = true;
    }
    this.parsys = this.$el.querySelector('.parsys');
    this.initMansonry();
  }
}
